import React, {
  useState,
  useRef,
  useContext
}                                 from 'react';
import { useTranslation}          from 'react-i18next';
import { toast }                  from 'react-toastify';
import TourImageContext           from '../context';
import Image                      from '@material-ui/icons/Image';
import List                       from '~/containers/List';
import Request                    from '~/providers/Request';
import ModalDelete                from '~/components/ModalDelete';
import ModalImage                 from '~/components/ModalImage';
import { newTourImage,
  editTourImage,
  showTourImage
}                                 from '~/config/routes';
import { URL }                    from '~/config/uri';
import moment                     from 'moment';
import { AbilityContext }         from '~/contexts/Can';

function TourImageList() {
  const { t } = useTranslation();
  const trAttr = (attr) => t(`tourImage.attributes.${attr}`);
  const [modalInfo, setModalInfo] = useState({ show: false });
  const [modalImage, setModalImage] = useState({ show: false });
  const { delRecord } = useContext(TourImageContext);
  const ability = useContext(AbilityContext);
  const listEl = useRef(null);

  function handleDeletionModal(id, name){
    setModalInfo({ show: true, id, name });
  }

  function handleMouse(url){
    setModalImage({ show: true, url: url });
  }

  async function handleDelete(){
    try {
      await Request.del(`/admin/tour_images/${modalInfo.id}`);
      delRecord(modalInfo.id);
      listEl.current.onQueryChange();
      toast.success(t('delete-toast-success'));
    } catch(e) {
      toast.error(t('delete-toast-fail'));
    } finally {
      setModalInfo({ show: false });
    }
  }

  const actions = [
    'search',
    'filter',
  ];

  if(ability.can('new', 'TourImages')) {
    actions.push('new');
  }
  if(ability.can('edit', 'TourImages')) {
    actions.push('edit');
  }
  if(ability.can('delete', 'TourImages')) {
    actions.push('del');
  }
  if(ability.can('show', 'TourImages')) {
    actions.push('show');
  }

  return (
    <div>
      <List
        deleteAction={handleDeletionModal}
        routeToNew={newTourImage}
        routeToEdit={editTourImage}
        routeToShow={showTourImage}
        listEl={listEl}
        path={'/admin/tour_images/'}
        actions={actions}
        paperProps={{
          Icon: Image,
          iconColor: 'blue',
          title: t('TourImage'),
        }}
        columns={[
          { title: trAttr('preview'), field: 'url', type: 'string' },
          { title: trAttr('is_active'), field: 'is_active', type: 'boolean' },
          { title: trAttr('name'), field: 'name', type: 'string' },
          { title: trAttr('sorter'), field: 'sorter', type: 'numeric' },
        ]}
        context={TourImageContext}
        recordMap={
          record => ({
            ...record,
            url: record.image ? <img src={`${URL}${record.image.file_path}`} onClick={()=> handleMouse(`${URL}${record.image.file_path}`)} style={{width: 50}}/> : null,
            created_at: record.created_at ? moment(record.created_at).format('DD/MM/YYYY HH:mm') : null,
            updated_at: record.updated_at ? moment(record.updated_at).format('DD/MM/YYYY HH:mm') : null,
          })
        }
      />
      <ModalDelete
        id={modalInfo.id}
        name={modalInfo.name}
        modal={modalInfo.show}
        deleteAction={handleDelete}
        onClose={() => setModalInfo({ show: false })}
      />
      <ModalImage
        modal={modalImage.show}
        url={modalImage.url}
        onClose={() => setModalImage({ show: false })}
      />
    </div>
  );
}

export default React.memo(TourImageList);
